// extracted by mini-css-extract-plugin
export default {"diagramcontainer":"index_diagramcontainer__9Yuqs","pdr18":"index_pdr18__sg9Xd"};